import React, { forwardRef, useLayoutEffect, useRef } from 'react';

// An <iframe> that stops the page's speech when it is taken away. Chrome keeps speaking a removed frame's
// speechSynthesis queue (a closed lesson went on talking for 40 seconds), so the cancel has to run while the frame
// is still on the page: a layout effect's cleanup runs before React removes the element.
const SilentFrame = forwardRef(function SilentFrame(props, ref) {
  const own = useRef(null);
  const setRef = (el) => {
    own.current = el;
    if (typeof ref === 'function') ref(el);
    else if (ref) ref.current = el;
  };
  useLayoutEffect(() => () => silenceFrame(own), []);
  return <iframe ref={setRef} {...props} />; // eslint-disable-line jsx-a11y/iframe-has-title -- callers pass title
});

export function silenceFrame(ref) {
  try { ref.current?.contentWindow?.speechSynthesis?.cancel(); } catch { /* cross-origin frame */ }
  try { window.speechSynthesis?.cancel(); } catch { /* no speech support */ }
}

export default SilentFrame;
